<template>
  <div
    v-if="ad && visible"
    class="m-ad--top-bubble-wrap"
    tabindex="0"
  >
    <a
      class="m-ad--top-bubble"
      @blur="close"
      @click.stop="handleClick"
    >
      <img
        :src="ad.image"
        :width="width"
        :alt="ad.text"
      >
    </a>

    <svg-icon
      class="m-close-btn"
      icon-class="icon-close"
      @click.stop="handleClose"
    />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import cookie from '@ms/utils/cookie.js'
import eventBus from '@ms/utils/event-bus.js'
import { getAdInfo } from 'wap/common/api'
import 'base/icons/svg/close.svg'

const keyPrefix = 'HOME_TOP_BUBBLE'

export default {
  name: 'TopBubbleAd',
  setup () {
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    return {
      loginStatus
    }
  },
  data () {
    return {
      visible: false,
      userId: '',
      width: 0,
      ad: null
    }
  },
  created () {
    eventBus.$on('close_topBubbleAd', status => {
      if (status) this.close()
    })
  },
  mounted () {
    if (this.loginStatus) {
      this.fetchData()
    } else {
      const unwatch = this.$watch('loginStatus', (val) => {
        if (val) {
          this.fetchData()
          unwatch()
        }
      })
    }
  },
  methods: {
    async fetchData () {
      try {
        const data = await getAdInfo(['HomeTopBubble'])
        if (data && data[0]) {
          const { ads } = data[0]
          this.ad = ads && ads[0]
          if (this.ad) {
            this.showBubble()
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    renderImage () {
      const img = new Image()
      img.onload = () => {
        this.visible = true
        this.$nextTick(() => {
          if (this.loginStatus) {
            this.$el.focus()
          }
          this.width = img.width / 2
        })
      }
      img.src = this.ad.image
    },
    showBubble () {
      this.userId = cookie.get('userId')
      const localKey = `${keyPrefix}_${this.userId}`
      const hasViewed = localStorage.getItem(localKey)
      if (!hasViewed) {
        this.renderImage()
      }
    },
    close () {
      this.visible = false
      localStorage.setItem(`${keyPrefix}_${this.userId}`, 1)
    },
    handleClick () {
      // 没配置链接的话，不做跳转
      if (this.ad.href) {
        location.href = this.ad.href
      }
      this.close()
    },
    handleClose () {
      this.close()
      window.mstrace('Home_IconClose')
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~wap/common/style/variable.less");

.m-ad--top-bubble-wrap {
  position: absolute;
  z-index: 9;
  top: 40px;
  right: 5px;
  appearance: none;
  outline: none;

  .m-close-btn {
    position: absolute;
    z-index: 1;
    top: 9px;
    right: 0;
    display: block;
    padding: 3px;
    color: #fff;
    font-size: 10px;
  }

  img {
    max-width: 100vw;
  }
}

.m-ad--top-bubble {
  display: block;
  outline: none;
}
</style>
